/**
 * Legacy device UUID shape (used only to recognize old `sessions.user_id` rows).
 * Visit storage and tap logging now use Firebase Auth UID — no klerk device cookie.
 */

/**
 * @param {string | null | undefined} s
 * @returns {boolean}
 */
export function isValidClientUuid(s) {
  return (
    typeof s === "string" &&
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(s)
  );
}

/** @internal Jest / manual debugging only */
export function __clearDeviceIdForTests() {
  /* no-op: device cookie / localStorage id removed */
}
